import styled from 'styled-components'

export const ComingSoonTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  padding-top: 48px;
`

export const Sorry = styled.div`
  color: #8c8c8c;
  font-size: 14px;
  font-weight: 400;
  padding-top: 16px;
`

export const ComingSoonCenterization = styled.div`
  margin-top: 15%;
  text-align: center;
`
